import { render, staticRenderFns } from "./wordsEvaluation.vue?vue&type=template&id=634948dc&scoped=true&"
import script from "./wordsEvaluation.vue?vue&type=script&lang=js&"
export * from "./wordsEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./wordsEvaluation.vue?vue&type=style&index=0&id=634948dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634948dc",
  null
  
)

export default component.exports